import React from "react";
import { CheckCircle } from "lucide-react";
import TodoItem from "./TodoItem";

const TodoList = ({
  filteredTodos,
  theme,
  screenSize,
  t,
  onToggle,
  onDelete,
}) => {
  if (filteredTodos.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: screenSize.isMobile ? "40px 20px" : "50px 24px",
          background:
            theme === "dark"
              ? "linear-gradient(145deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01))"
              : "linear-gradient(145deg, #ffffff, #f8fafc)",
          borderRadius: "18px",
          border:
            theme === "dark"
              ? "2px dashed rgba(255,255,255,0.1)"
              : "2px dashed rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            width: screenSize.isMobile ? 60 : 70,
            height: screenSize.isMobile ? 60 : 70,
            margin: "0 auto 20px",
            borderRadius: "50%",
            background:
              "linear-gradient(135deg, rgba(16, 185, 129, 0.15), rgba(5, 150, 105, 0.1))",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CheckCircle
            size={screenSize.isMobile ? 30 : 36}
            color="#2e7cba"
            strokeWidth={2}
          />
        </div>
        <div
          style={{
            fontSize: screenSize.isMobile ? 16 : 18,
            fontWeight: 700,
            color: theme === "dark" ? "#fff" : "#1a1a1a",
            marginBottom: "8px",
          }}
        >
          {t.noTasks}
        </div>
        <div
          style={{
            fontSize: screenSize.isMobile ? 13 : 14,
            color:
              theme === "dark" ? "rgba(255,255,255,0.6)" : "rgba(0,0,0,0.6)",
          }}
        >
          {t.noTasksDescription}
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {filteredTodos.map((todo, index) => (
        <TodoItem
          key={todo.id}
          todo={todo}
          index={index}
          theme={theme}
          screenSize={screenSize}
          t={t}
          onToggle={onToggle}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default TodoList;
